const newSurveyReducer = (state = false, action) => {
    switch (action.type) {
      case "SET_NEW_SURVEY":
        return action.payload;
      default:
        return state;
    }
  }
  export default newSurveyReducer;